// App.jsx
import React, { useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CognitoAuthProvider, useAuth } from './auth/CognitoAuthContext';
import {isMaintenanceMode} from './utilities/constants.jsx';

import theme from './theme';

import LoginPage from './pages/LoginPage';

import MainApp from './MainApp';
import MaintenancePage from './pages/MaintenancePage';

function AppRoutes() {
  const auth = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  if (auth.isLoading) {
    return <div>Loading authentication status...</div>;
  }

  return (
    <Routes>
      {/* Login (default) */}
      <Route path="/" element={<LoginPage />} />

      {/* Protected App Routes */}
      <Route
        path="/app"
        element={
          auth.isAuthenticated ? (
            <MainApp
              isLoggingOut={isLoggingOut}
              setIsLoggingOut={setIsLoggingOut}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      {/* Fallback: redirect unknown paths to login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <CognitoAuthProvider>
      <ThemeProvider theme={theme}>
          {isMaintenanceMode ? <MaintenancePage /> : <AppRoutes />}
      </ThemeProvider>
    </CognitoAuthProvider>
  );
}

export default App;
